const composeSerializers = function () {
  for (var _len = arguments.length, serializers = new Array(_len), _key = 0; _key < _len; _key++) {
    serializers[_key] = arguments[_key];
  }
  return function () {
    for (let i = 0; i < serializers.length; i++) {
      const serializer = serializers[i];
      if (serializer) {
        const res = serializer(...arguments);
        if (res != null) {
          return res;
        }
      }
    }
  };
};
export { composeSerializers };